import { getTiers } from '@/api/paid-tier';
import { prepareGetUpgradeOptions } from '@/utils/features';

export default {
  namespaced: true,
  state: {
    loaded: false,
    loading: false,
    tiers: null,
    features: {},
    quotas: {},
    featuresForCurrentTier: null,
  },
  mutations: {
    setLoading(state, isLoading) {
      state.loading = isLoading;
    },
    setTiers(state, tiers) {
      state.tiers = tiers;
    },
    setFeatures(state, features) {
      state.features = features;
    },
    setQuotas(state, quotas) {
      state.quotas = quotas;
    },
    setLoaded(state, isLoaded) {
      state.loaded = isLoaded;
    },
    setCurrentTierFeatures(state, features) {
      state.featuresForCurrentTier = features;
    },
  },
  actions: {
    async load({ state, commit, dispatch, rootGetters }) {
      if (!state.loaded) {
        try {
          commit('setLoading', true);
          const { data } = await getTiers();
          commit('setTiers', data.tiers);
          commit('setFeatures', data.features);
          commit('setQuotas', data.quotas);
          commit('setLoaded', true);

          const userFeatures = rootGetters['user/userFeatures'];
          commit('setCurrentTierFeatures', userFeatures);
        } catch (e) {
          dispatch('errorOverlay/setMessage', e, { root: true });
          throw e;
        } finally {
          commit('setLoading', false);
        }
      }
    },
  },
  getters: {
    loading: state => state.loading,
    tiers: state => state.tiers,
    features: state => state.features,
    quotas: state => state.quotas,
    featuresForCurrentTier: state => state.featuresForCurrentTier,
    getFeatureUpgradeOptions: (state, getters) => prepareGetUpgradeOptions(getters.featuresForCurrentTier),
  },
};
